import { useQuery } from '@tanstack/react-query';

import { standbyPublicShopQuery } from '@/api/standby/standbyPublicShopQuery';

import type { UseStandbyPublicShopQueryOptions } from './types';

export const useStandbyPublicShopQuery = (
  shopIdOrRoute?: string,
  options?: UseStandbyPublicShopQueryOptions,
) =>
  useQuery({
    ...standbyPublicShopQuery(shopIdOrRoute),
    ...options,
    // A caller's `enabled` must never re-open the factory's required-ID
    // guard — without this, `{ enabled: true }` with no shopIdOrRoute would
    // fire a query whose queryFn throws.
    enabled: !!shopIdOrRoute && (options?.enabled ?? true),
  });
